export const LAPSE_THRESHOLD_MS = 309;
export const MAJOR_LAPSE_THRESHOLD_MS = 1000;
